export const SAVE_AS_DRAFT = 'superUser/SAVE_AS_DRAFT';
export const RETRIEVE_DRAFT = 'superUser/RETRIEVE_DRAFT';
